var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.027 18.2035C5.50901 18.2035 1.83701 14.5315 1.83701 10.0135C1.83701 5.49549 5.50901 1.82349 10.027 1.82349C14.545 1.82349 18.217 5.49549 18.217 10.0135C18.217 14.5315 14.5405 18.2035 10.027 18.2035ZM10.027 2.90349C6.10751 2.90349 2.91701 6.09399 2.91701 10.0135C2.91701 13.933 6.10751 17.1235 10.027 17.1235C13.9465 17.1235 17.137 13.933 17.137 10.0135C17.137 6.09399 13.9465 2.90349 10.027 2.90349Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0135 13.708C9.8335 13.708 9.667 13.636 9.5365 13.51L6.5395 10.513C6.2785 10.252 6.2785 9.82453 6.5395 9.56353L9.5365 6.56653C9.6625 6.44053 9.8335 6.36853 10.0135 6.36853C10.1935 6.36853 10.36 6.44053 10.4905 6.56653L13.4875 9.56353C13.6135 9.68953 13.6855 9.86053 13.6855 10.0405C13.6855 10.2205 13.6135 10.387 13.4875 10.5175L10.4905 13.51C10.3645 13.636 10.1935 13.708 10.0135 13.708ZM7.597 10.0405L10.0135 12.457L12.43 10.0405L10.0135 7.62403L7.597 10.0405Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon_8.51badf4b4103286b233ccee4f62acc80.svg";
export { ForwardRef as ReactComponent };